import pimg1 from '../images/project/project-1/1.jpg'
import pimg2 from '../images/project/project-1/2.jpg'
import pimg3 from '../images/project/project-1/3.jpg'
import pimg4 from '../images/project/project-1/4.jpg'
import pimg5 from '../images/project/project-1/5.jpg'
import pimg6 from '../images/project/project-1/6.jpg'
import pimg7 from '../images/project/project-1/7.jpg'
import pimg8 from '../images/project/project-1/8.jpg'

// import pimg9 from '../images/project/project-2/1.png'
// import pimg10 from '../images/project/project-2/2.jpg'
// import pimg11 from '../images/project/project-2/3.jpg'
// import pimg12 from '../images/project/project-2/4.jpg'
// import pimg13 from '../images/project/project-2/5.jpg'
// import pimg14 from '../images/project/project-2/6.png'
// import pimg15 from '../images/project/project-2/7.jpg'
// import pimg16 from '../images/project/project-2/8.jpg'
// import pimg17 from '../images/project/project-2/9.jpg'
// import pimg18 from '../images/project/project-2/10.jpg'
// import pimg19 from '../images/project/project-2/11.png'
// import pimg20 from '../images/project/project-2/12.jpg'
// import pimg21 from '../images/project/project-2/13.jpg'
// import pimg22 from '../images/project/project-2/14.jpg'
// import pimg23 from '../images/project/project-2/15.jpg'
// import pimg24 from '../images/project/project-2/16.jpg'
// import pimg25 from '../images/project/project-2/17.jpg'
// import pimg26 from '../images/project/project-2/18.jpg'
// import pimg27 from '../images/project/project-2/19.jpg'
// import pimg28 from '../images/project/project-2/20.jpg'
// import pimg29 from '../images/project/project-2/21.jpg'
// import pimg30 from '../images/project/project-2/22.jpg'

// import pimg31 from '../images/project/project-2/23.png'
// import pimg32 from '../images/project/project-2/24.png'
// import pimg33 from '../images/project/project-2/25.png'
// import pimg34 from '../images/project/project-2/26.png'
// import pimg35 from '../images/project/project-2/27.png'
// import pimg36 from '../images/project/project-2/28.png'
// import pimg37 from '../images/project/project-2/29.png'
// import pimg38 from '../images/project/project-2/30.png'
// import pimg39 from '../images/project/project-2/31.png'
// import pimg40 from '../images/project/project-2/32.png'
// import pimg41 from '../images/project/project-2/33.png'
// import pimg42 from '../images/project/project-2/34.png'
// import pimg43 from '../images/project/project-2/35.png'
// import pimg44 from '../images/project/project-2/36.png'
// import pimg45 from '../images/project/project-2/37.png'
// import pimg46 from '../images/project/project-2/38.png'
// import pimg47 from '../images/project/project-2/39.png'
// import pimg48 from '../images/project/project-2/40.png'
// import pimg49 from '../images/project/project-2/41.png'
// import pimg50 from '../images/project/project-2/42.png'
// import pimg51 from '../images/project/project-2/43.png'

// import pimg52 from '../images/project/project-1/9.png'
// import pimg53 from '../images/project/project-1/10.png'
// import pimg54 from '../images/project/project-1/11.png'
// import pimg55 from '../images/project/project-1/12.png'
// import pimg56 from '../images/project/project-1/13.png'
// import pimg57 from '../images/project/project-1/14.png'
// import pimg58 from '../images/project/project-1/15.png'
// import pimg59 from '../images/project/project-1/16.png'
// import pimg60 from '../images/project/project-1/17.png'
// import pimg61 from '../images/project/project-1/18.png'
// import pimg62 from '../images/project/project-1/19.png'
// import pimg63 from '../images/project/project-1/20.png'
// import pimg64 from '../images/project/project-1/21.png'

// import pimg65 from '../images/project/project-1/22.png'
// import pimg66 from '../images/project/project-1/23.png'
// import pimg67 from '../images/project/project-1/24.png'
// import pimg68 from '../images/project/project-1/25.png'
// import pimg69 from '../images/project/project-1/26.png'
// import pimg70 from '../images/project/project-1/27.png'
// import pimg71 from '../images/project/project-1/28.png'
// import pimg72 from '../images/project/project-1/29.png'
// import pimg73 from '../images/project/project-1/30.png'
// import pimg74 from '../images/project/project-1/31.png'
// import pimg75 from '../images/project/project-1/32.png'
// import pimg76 from '../images/project/project-1/33.png'
// import pimg77 from '../images/project/project-1/34.png'
// import pimg78 from '../images/project/project-1/35.png'
// import pimg79 from '../images/project/project-1/36.png'
// import pimg80 from '../images/project/project-1/37.png'
// import pimg81 from '../images/project/project-1/38.png'
// import pimg82 from '../images/project/project-1/39.png'
// import pimg83 from '../images/project/project-1/40.png'
// import pimg84 from '../images/project/project-1/41.png'
// import pimg85 from '../images/project/project-1/42.png'
// import pimg86 from '../images/project/project-1/43.png'
// import pimg87 from '../images/project/project-1/44.png'
// import pimg88 from '../images/project/project-1/45.png'
// import pimg89 from '../images/project/project-1/46.png'
// import pimg90 from '../images/project/project-1/47.png'
// import pimg91 from '../images/project/project-1/48.png'
// import pimg92 from '../images/project/project-1/49.png'

const Projects = [
  // {
  //   id: '28',
  //   title: 'Construction',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg28,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '45',
  //   title: 'Hiwa City',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg47,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
 
  // {
  //   id: '35',
  //   title: 'Green Land City Roads',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg37,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '36',
  //   title: 'Green Land City Roads',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg38,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '29',
  //   title: 'Mass Village',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg29,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '30',
  //   title: 'Mass Village',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg30,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  
  // {
  //   id: '32',
  //   title: 'Mass Village',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg34,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '19',
  //   title: 'Construction',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg19,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '27',
  //   title: 'Mass Village',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg27,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  //  {
  //   id: '46',
  //   title: 'Construction',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg48,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  {
    id: '1',
    title: 'Modern Design Villa',
    subtitle: 'Design | Construction',
    slug: 'Modern-House',
    pimg: pimg1,
    // sing: Sing1,
    subTitle: 'e',
    date: 'March 2025',
    location: 'Austria',
  },
  {
    id: '2',
    title: 'Interior Design',
    subtitle: 'Design | Construction',
    slug: 'Modern-House',
    pimg: pimg2,
    subTitle: 'i',
    // sing: Sing2,
    date: 'March 2025',
    location: 'Austria',
  },
  {
    id: '3',
    title: 'Organic Design',
    subtitle: 'Design | Construction',
    slug: 'Interior-Design',
    pimg: pimg3,
    subTitle: 'e',
    // sing: Sing3,
    date: 'March 2025',
    location: 'Austria',
  },
  {
    id: '4',
    title: 'Neoclassic Design',
    subtitle: 'Design | Construction',
    slug: 'Interior-Design',
    pimg: pimg4,
    subTitle: 'e',
    // sing: Sing4,
    date: 'March 2025',
    location: 'Austria',
  },
  {
    id: '5',
    title: 'Minimalistic Design',
    subtitle: 'Design | Construction',
    slug: 'Modern-House2',
    pimg: pimg5,
    subTitle: 'i',
    // sing: Sing5,
    date: 'March 2025',
    location: 'Austria',
  },
  {
    id: '6',
    title: 'Kiosk Design',
    subtitle: 'Design | Construction',
    slug: 'Art-Museum',
    pimg: pimg6,
    subTitle: 'e',
    // sing: Sing6,
    date: 'March 2025',
    location: 'Austria',
  },
  {
    id: '7',
    title: 'Interior Design',
    subtitle: 'Design | Construction',
    slug: 'Farm-House',
    pimg: pimg7,
    subTitle: 'i',
    // sing: Sing7,
    date: 'March 2025',
    location: 'Austria',
  },
  {
    id: '8',
    title: 'Interior Design',
    subtitle: 'Design | Construction',
    slug: 'Dream-House',
    pimg: pimg8,
    subTitle: 'i',
    // sing: Sing8,
    date: 'March 2025',
    location: 'Austria',
  },
  // {
  //   id: '9',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg9,
  //   subTitle: 'i',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '10',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg10,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },

  // {
  //   id: '11',
  //   title: 'Villa',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg11,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '12',
  //   title: 'Green Land City',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg12,
  //   subTitle: 'e',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '13',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg13,
  //   subTitle: 'i',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '14',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg14,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '15',
  //   title: 'Private Guest Hall',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg15,
  //   subTitle: 'i',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '16',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg16,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '17',
  //   title: 'Villa',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg17,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '18',
  //   title: 'Modern Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg18,
  //   subTitle: 'e',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  
  
  // {
  //   id: '20',
  //   title: 'Construction',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg20,
  //   subTitle: 'c',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '21',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg21,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '22',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg22,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '23',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg23,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '24',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg24,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '25',
  //   title: 'Kitchen Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg25,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '26',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg26,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },

  // {
  //   id: '27',
  //   title: 'Construction',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg31,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '30',
  //   title: 'Construction',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg32,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '31',
  //   title: 'Construction',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg33,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '32',
  //   title: 'Mass Village',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg34,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '33',
  //   title: 'Construction',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg35,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '34',
  //   title: 'Mass Village',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg36,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  
  // {
  //   id: '37',
  //   title: 'Green Land City Roads',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg39,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '38',
  //   title: 'Construction',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg40,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '39',
  //   title: '‌Hospital',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg41,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '40',
  //   title: 'Green Land City Roads',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg42,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '41',
  //   title: 'Nanakali Hospital',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg43,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '42',
  //   title: 'Construction',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg44,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '43',
  //   title: 'Mihrabani Hospital',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg45,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '44',
  //   title: 'Construction',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg46,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  
  // {
  //   id: '47',
  //   title: 'Construction',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg49,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '48',
  //   title: 'Green Land City Roads',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg50,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '49',
  //   title: 'Construction',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg51,
  //   subTitle: 'c',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },

  // {
  //   id: '50',
  //   title: 'Basra Courthouse Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg52,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '51',
  //   title: 'Basra Courthouse Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg53,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '52',
  //   title: 'Basra Courthouse Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg54,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '53',
  //   title: 'Villa',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg55,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '54',
  //   title: 'House Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg56,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '55',
  //   title: 'Villa',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg57,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '56',
  //   title: 'Villa',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg58,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '57',
  //   title: 'Villa',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg59,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '58',
  //   title: 'Villa',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg60,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '59',
  //   title: 'Villa',
  //   subtitle: 'Design | Construction',
  //   slug: 'Farm-House',
  //   pimg: pimg61,
  //   subTitle: 'e',
  //   // sing: Sing7,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '60',
  //   title: 'Green Land City',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg62,
  //   subTitle: 'e',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '61',
  //   title: 'Green Land City',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg63,
  //   subTitle: 'e',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '62',
  //   title: 'Green Land City',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg64,
  //   subTitle: 'e',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },

  // {
  //   id: '63',
  //   title: 'Daya Gawra Restaurant',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg65,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '64',
  //   title: 'Daya Gawra Restaurant',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg66,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '65',
  //   title: 'Daya Gawra Restaurant',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg67,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '66',
  //   title: 'Daya Gawra Restaurant',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg68,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '67',
  //   title: 'Daya Gawra Restaurant',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg69,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '68',
  //   title: 'Daya Gawra Restaurant',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg70,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '69',
  //   title: 'Daya Gawra Restaurant',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg71,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '70',
  //   title: 'Daya Gawra Restaurant',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg72,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '71',
  //   title: 'Daya Gawra Restaurant',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg73,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '72',
  //   title: 'Daya Gawra Restaurant',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg74,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '73',
  //   title: 'Daya Gawra Restaurant',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg75,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '74',
  //   title: 'Daya Gawra Restaurant',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg76,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '75',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg77,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '76',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg78,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '77',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg79,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '78',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg80,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '79',
  //   title: 'Private Meeting Hall',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg81,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '80',
  //   title: 'Private Meeting Hall',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg83,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '81',
  //   title: 'Private Meeting Hall',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg84,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '82',
  //   title: 'Private Meeting Hall',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg85,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '83',
  //   title: 'Basra Private Office Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg86,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '84',
  //   title: 'Basra Private Office Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg87,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '85',
  //   title: 'Basra Private Office Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg88,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '86',
  //   title: 'Basra Private Office Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg89,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '87',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg90,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
  // {
  //   id: '88',
  //   title: 'Interior Design',
  //   subtitle: 'Design | Construction',
  //   slug: 'Dream-House',
  //   pimg: pimg82,
  //   subTitle: 'i',
  //   // sing: Sing8,
  //   date: 'March 2025',
  //   location: 'Austria',
  // },
]
export default Projects
